document.querySelectorAll('.mwn-studio').forEach((root) => {
  if (root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const audios = [...root.querySelectorAll('[data-audio]')];
  const bySize = new Map(
    audios.map((audio) => [audio.dataset.audio, audio])
  );

  const syncButton = (audio) => {
    const button = root.querySelector(
      `[data-play="${audio.dataset.audio}"]`
    );

    if (!button) return;

    const isPlaying = !audio.paused && !audio.ended;

    button.classList.toggle('is-playing', isPlaying);
    button.setAttribute(
      'aria-pressed',
      isPlaying ? 'true' : 'false'
    );

    const icon = button.querySelector('.mwn-play__icon');
    const text = button.querySelector('.mwn-play__text');

    if (icon) {
      icon.textContent = isPlaying ? '❚❚' : '▶';
    }

    if (text) {
      text.textContent = isPlaying ? 'Stop' : 'Listen';
    }
  };

  const resetAudio = (audio) => {
    audio.pause();

    try {
      audio.currentTime = 0;
    } catch (error) {
      // Some browsers may briefly reject seeking
      // before audio metadata is fully available.
    }

    syncButton(audio);
  };

  /*
   * INDIVIDUAL CHIME BUTTONS
   *
   * First click:
   *   Start from the beginning.
   *
   * Second click while playing:
   *   Stop and reset to 0:00.
   *
   * Next click:
   *   Start from the beginning again.
   */
  root.querySelectorAll('[data-play]').forEach((button) => {
    button.addEventListener('click', async () => {
      const audio = bySize.get(button.dataset.play);

      if (!audio) return;

      if (!audio.paused && !audio.ended) {
        resetAudio(audio);
        return;
      }

      /*
       * ALWAYS reset an individual recording before
       * starting it again. This prevents a previously
       * stopped sound from resuming in the middle.
       */
      audio.pause();

      try {
        audio.currentTime = 0;
      } catch (error) {}

      try {
        await audio.play();
      } catch (error) {}

      syncButton(audio);
    });
  });

  /*
   * KEEP BUTTON STATES SYNCHRONIZED
   */
  audios.forEach((audio) => {
    audio.addEventListener('play', () => {
      syncButton(audio);
    });

    audio.addEventListener('pause', () => {
      syncButton(audio);
    });

    audio.addEventListener('ended', () => {
      /*
       * Once a recording finishes naturally,
       * return it to the beginning as well.
       */
      try {
        audio.currentTime = 0;
      } catch (error) {}

      syncButton(audio);
    });
  });

  /*
   * STOP ALL SOUNDS
   */
  const stopAllButton = root.querySelector('[data-stop-all]');

  if (stopAllButton) {
    stopAllButton.addEventListener('click', () => {
      audios.forEach((audio) => {
        resetAudio(audio);
      });
    });
  }

  /*
   * PLAY RECOMMENDED PAIR
   */
  root.querySelectorAll('[data-play-pair]').forEach((button) => {
    button.addEventListener('click', async () => {
      const sizes = button.dataset.playPair.split('+');

      /*
       * Clear everything first so the pair
       * begins together from 0:00.
       */
      audios.forEach((audio) => {
        resetAudio(audio);
      });

      const pair = sizes
        .map((size) => bySize.get(size))
        .filter(Boolean);

      pair.forEach((audio) => {
        try {
          audio.currentTime = 0;
        } catch (error) {}
      });

      await Promise.allSettled(
        pair.map((audio) => audio.play())
      );

      pair.forEach((audio) => {
        syncButton(audio);
      });
    });
  });

  /*
   * STOP RECOMMENDED PAIR
   */
  root.querySelectorAll('[data-stop-pair]').forEach((button) => {
    button.addEventListener('click', () => {
      const sizes = button.dataset.stopPair.split('+');

      sizes
        .map((size) => bySize.get(size))
        .filter(Boolean)
        .forEach((audio) => {
          resetAudio(audio);
        });
    });
  });
});